import { UpcomingShow } from './upcoming-show';
import { ModelBase } from './base';
import { Profile } from './profile';
import { StoreFront } from './store';
import { LiveStream } from './livestream';

export interface Category extends ModelBase {
  // e.g. hawaii-toys
  slug: string;
  // full name, e.g. toys/hawaii-toys
  name: string;
  parentId?: string;
  // full name for the direct parent category
  parentName?: string;
  // root category slug
  rootCategory: string;
  title: string;
  description?: string;
  imageUrl?: string;
  sort: number;
  enabled: boolean;
}

export enum CategorizedResourceType {
  Store = 'STORE',
  UpcomingShow = 'UPCOMING_SHOW',
  LiveStream = 'LIVE_STREAM',
  User = 'USER',
}

export interface CategorizedResourceBase extends ModelBase {
  categoryId: string;
  category: Category;
  sort: number;
  resourceType: CategorizedResourceType;
}

export interface CategorizedStore extends CategorizedResourceBase {
  resourceType: CategorizedResourceType.Store;
  storeId: string;
  store: StoreFront;
  // For a given store, the category with the smallest sequenceNo will their primary category
  sequenceNo?: number;
  // using this field to do Firestore query
  isPrimary?: boolean;
}

export interface CategorizedUpcomingShow extends CategorizedResourceBase {
  resourceType: CategorizedResourceType.UpcomingShow;
  upcomingShowId: string;
  upcomingShow: UpcomingShow;
}

export interface CategorizedLiveStream extends CategorizedResourceBase {
  resourceType: CategorizedResourceType.LiveStream;
  liveStreamId: string;
  liveStream: LiveStream;
}

export interface CategorizedUser extends CategorizedResourceBase {
  resourceType: CategorizedResourceType.User;
  userId: string;
  user: Profile;
}

export type CategorizedResource =
  | CategorizedStore
  | CategorizedUpcomingShow
  | CategorizedLiveStream
  | CategorizedUser;
